import React from 'react';
import { List, ListItem, ListItemText, ListSubheader } from '@material-ui/core';
import { GreenCheckbox } from 'components/ExploreTalents/ExploreTalentsEmployeeCardConstants';

const MultiSelectList = ({ checkedItems, onChangeHandler, items, subheaderText, ...props }) => {
    return (
        <List
            {...props}
            subheader={
                <ListSubheader disableSticky className="list-sub-header">
                    {subheaderText}
                </ListSubheader>
            }
        >
            {items.map((value) => {
                const labelId = `checkbox-list-label-${value}`;

                return (
                    <ListItem key={value} onClick={() => onChangeHandler(value)} className="list-item">
                        <GreenCheckbox
                            edge="start"
                            checked={checkedItems.indexOf(value) !== -1}
                            tabIndex={-1}
                            disableRipple
                            inputProps={{ 'aria-labelledby': labelId }}
                        />
                        <ListItemText id={labelId} primary={value} />
                    </ListItem>
                );
            })}
        </List>
    );
};

export default MultiSelectList;
